import { Injectable } from '@angular/core';
import { DataSourceRequestState, SortDescriptor, DataResult, translateDataSourceResultGroups } from '@progress/kendo-data-query';
import { Observable, of } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { HttpRepo } from '@shared/services/httprepo';
import { AuthService } from '@services/auth.service';
import { ApiEndPointType } from '@shared/enums/common';
import { CommonMethods } from '@services/common.method';

@Injectable({
  providedIn: 'root'
})
export class LaborItemService {

  constructor(
    private auth: AuthService,
    private httpRepo:HttpRepo,
    private commonMethod: CommonMethods
  ) {
      this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(),ApiEndPointType.FS);
   }

  public fetchLaborItems(paymentTermData:any,state: DataSourceRequestState, sort:SortDescriptor[]): Observable<DataResult> 
  {
    const hasGroups = state.group && state.group.length;
    return of({data: paymentTermData.LaborItems,total:paymentTermData.Count}) // Send the state to the server
        .map(({data, total} : GridDataResult) => // Process the response
            (<GridDataResult>{
                data: hasGroups ? translateDataSourceResultGroups(data) : data,
                total: total,
            })
        )
  }
   // GET Labor Item
   GetLaborItem(data :any){
    return this.httpRepo.Get("pricebook/laboritems/"+ data.params.ID+"?references=Category,AccountingCode,Prices");
  }

  // GET Labor Item
  GetLaborItems(state:any, searchKey:string){
    return this.httpRepo.Get("pricebook/laboritems");
  }

  // PUT
  public EditLaborItem(params:any,data :any):Observable<any>{
    return this.httpRepo.Put("pricebook/laboritems/" + params.ID, data);
  }
  // POST
    public SaveLaborItem(data: any): Observable<any>{
     data.ID = CommonMethods.GetID();
    return this.httpRepo.Post("pricebook/laboritems",data);
  }
}
